import { Component, AfterViewInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-mat-table',
  templateUrl: './mat-table.component.html',
  styleUrls: ['./mat-table.component.scss']
})
export class MatTableComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Output() selectedToParent = new EventEmitter<any>();
  @Output() selectedPage = new EventEmitter<any>();

  @Input() modelDataSource: any[] = [];
  @Input() headerColumns: string[] = [];
  @Input() selectButttonName: string = "Select";
  @Input() showPagination: boolean = true;  
  @Input() enableSearch: boolean = false; 
  @Input() fromEqSearch: boolean;
  @Input() message: boolean = false;  
  @Input() pageWiseApi: boolean = false;
  @Input() pageLength: number = 0;
  @Input() pageIndex: number = 0;
  @Input() pageSize: number = 10;  

  dataSource = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 50, 100, 250, 500, 1000];
  selectedId: number;
  filterText: string = '';
  subject = new Subject();

  constructor() { }

  ngOnInit(): void {
    this.subscribeFilterTextChangeEvent();
  }

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.modelDataSource);
    if (!this.pageWiseApi) { this.dataSource.paginator = this.paginator; }
  }

  applyFilter(filterValue: string) {
    this.filterText = filterValue;
    this.subject.next(this.filterText);
  }

  subscribeFilterTextChangeEvent() {
    this.subject
      .asObservable()
      .pipe(debounceTime(1000))
      .subscribe((data: string) => {
        if (data.trim().length >= 3) {
          let filterText = { filterText: data.trim(), pageIndex: 0, pageSize: this.pageSize };
          this.selectedPage.emit(filterText);
        }
        else if (data.trim().length == 0) {
          this.selectedPage.emit({});
        }
      });
  }

  onRadioSelected(value: any) {
    this.selectedId = value;
  }

  sendToParent() {
    this.selectedToParent.emit(this.selectedId);
  }

  onPageChange(event: PageEvent) {
    let evt = { ...event, ...{ pageChangeEvent: true }, ...(this.filterText.trim().length >= 3) ? { filterText: this.filterText.trim() } : {} }
    this.selectedPage.emit(evt);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataSource = new MatTableDataSource(this.modelDataSource);
  }

}
